import { useState, useEffect } from 'react';
import Select from 'react-select';

const SearchableSelect = ({ coordenates, handleSelectCoordenate, selectedValueUp, placeHolder }) => {
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState(selectedValueUp);

    useEffect(() => {
        if(coordenates) {
            const selectOptions = coordenates.map(coordenate => {
                return { value: coordenate.value, label: coordenate.label }
            })

            setOptions(selectOptions)
        }
    }, [coordenates])

    const handleChange = (selectedVal) => {
        setSelectedValue(selectedVal);
        handleSelectCoordenate(selectedVal)
    }

    return (
        <Select
            isDisabled={!options.length}
            options={options}
            isSearchable
            placeholder={placeHolder}
            onChange={handleChange}
            value={!selectedValueUp ? "" : selectedValue}
        />
    );
};

export default SearchableSelect;